<template>
<div class="about-our-three height">
  <div class="about-our-wrap">
    <div class="about-our-top">
      <div class="about-our-top-left">
        <img class="about-our-top-img" src="../assets/untitled-98.png">
      </div>
      <div class="about-our-top-text">
        <p class="about-our-top-yellow">基于云计算平台和移动互联技术自主研发、运营的酒店人力外包管理信息化平台，形成酒店工单管理、家政人力管理、员工作业终端的三方协作闭环。</p>
        <p  class="about-our-top-white">依托技术平台，建立标准化工序和操作规范，作业流程信息化，记件，结算信息一目了然；依托自身行业专家，搭建培训体系和考核标准；依托完善的运营体系，人力服务供需双方可以实时、高效的交换信息，为酒店快速发展提供弹性的、优异的人力资源。</p>
      </div>
    </div>
    <div class="about-our-bottom">
      <div class="about-our-bottom-info">
<!--        <div class="about-our-info-text">-->
          <ul class="about-our-info-text  about-our-info-text-left col-xs-6 col-sm-6 col-md-6 col-lg-5">
            <li><span class="circle"></span><b class="about-our-bolder">员工培养体系</b><br/>
              <span class="about-our-size">为每个外包员工提供体系化的培训服务，按照培训体系对人员进行能力评级，根据工单完成的通过率，评价等，对人员的能力进行跟踪培养，确保每个人员都能提供符合标准的人力服务。</span>
            </li>
            <li><span class="circle"></span><b class="about-our-bolder">评价反馈体系</b><br/>
              <span class="about-our-size">酒店可以基于人力服务的各个力度提出评价，人力公司可实时关注到各个评价指标，做出相应的运营反馈，平台根据一些硬性的评价指标，调整相关算法的执行等级。</span>
            </li>
          </ul>
<!--        </div>-->
<!--        <div class="about-our-info-text">-->
          <ul class="about-our-info-text col-xs-6 col-sm-6 col-md-6 col-lg-5">
            <li><span class="circle"></span><b class="about-our-bolder">工单作业体系</b><br/>
              <span class="about-our-size">平台提供酒店、人力公司、外派员工三方协作工具：包含签约、派工、派单、抢单、作业、完成、验收、撤工、工单报表等功能。</span>
            </li>
            <li><span class="circle"></span><b class="about-our-bolder">云计算微服务</b><br/>
              <span class="about-our-size">平台基于模块化开发，功能内聚，领域边界清晰；按微服务架构部署，便于横向扩展；适应云计算环境，可以充分发挥云计算平台的弹性资源优势，应对业务峰值，节约硬件成本。</span>
            </li>
          </ul>
<!--        </div>-->
      </div>
<!--      <div class="about-our-top-last">-->
        <ul class="about-our-top-last col-xs-12 col-sm-12 col-md-12  col-lg-10">
          <li><span class="circle"></span><b class="about-our-bolder">数据安全</b><br/>
            <span class="about-our-size">业务数据按多租户方式隔离存储，确保租户数据安全；关键用户信息加密存储，避免用户信息泄露；数据库实时备份，避免每一笔交易数据丢失。</span>
          </li>
        </ul>
<!--      </div>-->
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: "AboutOurThree",
    data() {
      return {
        style: ''
      }
    },
    methods:{
    },
    mounted() {
      this.style = `height:${window.innerHeight -60}px;`
    },
  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/index.scss';

  @media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 870px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      /*height: calc(100vh - 60px);*/
      height: calc(100vh - 60px);
    }
  }
  @media screen and (max-width: 768px) {
      // .height{
      //   height: 900px;
      // }
    .about-our-three{
      width: 100%;
      background: url("../assets/untitled-95.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
      .about-our-top-text{
        // @include px2rem(width, 412);
        width: 60%;
        /*margin: auto 0;*/
        p{
          text-align: left;
          @include px2rem(font-size, 20);
          font-weight: 600;
          @include px2rem(line-height, 42);
        }
      }
    .about-our-info-text-left{
      margin-left: 0px;
    }
    .about-our-info-text{
      // @include px2rem(width, 637);
      width: 100%;
      display: block;
      margin-bottom: 0px;
        li {
         /* @include px2rem(width, 323);*/
          /*width: 95%;*/
          // @include px2rem(height, 138);
          /*height: 100px;*/
         /* min-height: 140px;*/
          @include px2rem(line-height, 30);
          /*line-height: 24px;*/
          @include px2rem(padding, 10);
          /*padding: 8px;*/
          color: #ffffff;
          text-align: left;
          border: 1px dashed #fff;
          @include px2rem(border-radius, 14);
          /*border-radius: 10px;*/
          list-style-type: none;
          @include px2rem(margin-bottom, 20);
          /*margin-top: 20px;*/
        }
      }
      .about-our-top-last{
        // width: 98%;
        margin-bottom: 0;
        li{
          width: 100%;
          // height: 50px;
          @include px2rem(line-height, 30);
          /*line-height: 24px;*/
          @include px2rem(padding, 4);
          /*padding: 8px;*/
          color: #ffffff;
          text-align: left;
          border: 1px dashed #fff;
          @include px2rem(margin-bottom, 20);
          margin-bottom: 20px;
          @include px2rem(border-radius, 14);
          /*border-radius: 10px;*/
          list-style-type: none;
          // @include px2rem(margin-top, 28);
          /*margin-top: 20px;*/
        }
      }
    .about-our-bolder{
      @include px2rem(font-size, 20);
      /*font-size: 16px;*/
    }
    .about-our-size{
      @include px2rem(font-size, 18);
      /*font-size: 13px;*/
    }
    .about-our-top-img{
      /* width: 100%;
       height: 100%;*/
      @include px2rem(width, 180);
      @include px2rem(height, 180);
    }
  }
  @media(min-width: 768px) and (max-width: 992px){
 /*   .height{
      height: calc(100vh - 60px);
    }*/
    .height{
      height: 900px;
    }
    .about-our-three{
      width: 100%;
      background: url("../assets/untitled-95.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .about-our-top-text{
      // @include px2rem(width, 412);
      width: 60%;
      /*margin: auto 0;*/
      p{
        text-align: left;
        @include px2rem(font-size, 20);
        font-weight: 600;
        @include px2rem(line-height, 42);
      }
    }
    .about-our-info-text-left{
      margin-left: 0px;
    }
    .about-our-info-text{
      // @include px2rem(width, 637);
      width: 100%;
      display: block;
      margin-bottom: 0px;
      li {
        /* @include px2rem(width, 323);*/
        /*width: 95%;*/
        // @include px2rem(height, 138);
        /*height: 100px;*/
        /* min-height: 140px;*/
        @include px2rem(line-height, 30);
        /*line-height: 24px;*/
        @include px2rem(padding, 10);
        /*padding: 8px;*/
        color: #ffffff;
        text-align: left;
        border: 1px dashed #fff;
        @include px2rem(border-radius, 14);
        /*border-radius: 10px;*/
        list-style-type: none;
        @include px2rem(margin-bottom, 20);
        /*margin-top: 20px;*/
      }
    }
    .about-our-top-last{
      // width: 98%;
      margin-bottom: 0;
      li{
        width: 100%;
        // height: 50px;
        @include px2rem(line-height, 30);
        /*line-height: 24px;*/
        @include px2rem(padding, 4);
        /*padding: 8px;*/
        color: #ffffff;
        text-align: left;
        border: 1px dashed #fff;
        @include px2rem(margin-bottom, 20);
        margin-bottom: 20px;
        @include px2rem(border-radius, 14);
        /*border-radius: 10px;*/
        list-style-type: none;
        // @include px2rem(margin-top, 28);
        /*margin-top: 20px;*/
      }
    }
    .about-our-bolder{
      @include px2rem(font-size, 20);
      /*font-size: 16px;*/
    }
    .about-our-size{
      @include px2rem(font-size, 18);
      /*font-size: 13px;*/
    }
    .about-our-top-img{
      /* width: 100%;
       height: 100%;*/
      @include px2rem(width, 180);
      @include px2rem(height, 180);
    }
  }
  @media(min-width: 992px) and (max-width: 1200px){
 /*   .height{
      height: calc(100vh - 60px);
    }*/
    .height{
      height: 900px;
    }
    .about-our-three{
      width: 100%;
      background: url("../assets/untitled-95.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .about-our-top-text{
      // @include px2rem(width, 412);
      width: 60%;
      /*margin: auto 0;*/
      p{
        text-align: left;
        @include px2rem(font-size, 20);
        font-weight: 600;
        @include px2rem(line-height, 42);
      }
    }
    .about-our-info-text-left{
      margin-left: 0px;
    }
    .about-our-info-text{
      // @include px2rem(width, 637);
      width: 100%;
      display: block;
      margin-bottom: 0px;
      li {
        /* @include px2rem(width, 323);*/
        /*width: 95%;*/
        // @include px2rem(height, 138);
        /*height: 100px;*/
        /* min-height: 140px;*/
        @include px2rem(line-height, 30);
        /*line-height: 24px;*/
        @include px2rem(padding, 10);
        /*padding: 8px;*/
        color: #ffffff;
        text-align: left;
        border: 1px dashed #fff;
        @include px2rem(border-radius, 14);
        /*border-radius: 10px;*/
        list-style-type: none;
        @include px2rem(margin-bottom, 20);
        /*margin-top: 20px;*/
      }
    }
    .about-our-top-last{
      // width: 98%;
      margin-bottom: 0;
      li{
        width: 100%;
        // height: 50px;
        @include px2rem(line-height, 30);
        /*line-height: 24px;*/
        @include px2rem(padding, 4);
        /*padding: 8px;*/
        color: #ffffff;
        text-align: left;
        border: 1px dashed #fff;
        @include px2rem(margin-bottom, 20);
        margin-bottom: 20px;
        @include px2rem(border-radius, 14);
        /*border-radius: 10px;*/
        list-style-type: none;
        // @include px2rem(margin-top, 28);
        /*margin-top: 20px;*/
      }
    }
    .about-our-bolder{
      @include px2rem(font-size, 20);
      /*font-size: 16px;*/
    }
    .about-our-size{
      @include px2rem(font-size, 18);
      /*font-size: 13px;*/
    }
    .about-our-top-img{
      /* width: 100%;
       height: 100%;*/
      @include px2rem(width, 180);
      @include px2rem(height, 180);
    }
  }
  @media screen and (min-width: 1200px) {
    // .height{
    //   height: 600px;
    //   /*height: calc(100vh - 60px);*/
    // }
    .about-our-three{
      width: 100%;
      background: url("../assets/untitled-95.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
      .about-our-top-text{
        // @include px2rem(width, 1140);
        width: 60%;
        /*margin: auto 0;*/
        p{
          text-align: left;
          @include px2rem(font-size, 20);
          font-weight: 600;
          @include px2rem(line-height, 42);
        }
      }
    .about-our-info-text-left{
      margin-left: 120px;
    }
      .about-our-info-text{
        // @include px2rem(width, 637);
        width: 42%;
        display: block;
        margin-bottom: 0px;
        li {
          /*@include px2rem(width, 623);*/
          /*width: 90%;*/
          // @include px2rem(height, 138);
          /*height: 100px;*/
          /*min-height: 120px;*/
          @include px2rem(line-height, 33);
          /*line-height: 24px;*/
          @include px2rem(padding, 10);
          /*padding: 8px;*/
          color: #ffffff;
          text-align: left;
          border: 1px dashed #fff;
          @include px2rem(border-radius, 14);
          /*border-radius: 10px;*/
          list-style-type: none;
          @include px2rem(margin-bottom, 28);
          /*margin-top: 20px;*/
        }
      }
      .about-our-top-last{
        margin-bottom: 0;
        margin-left: 120px;
        // width: 98%;
        li{
          width: 100%;
          // height: 50px;
          @include px2rem(line-height, 33);
          /*line-height: 24px;*/
          @include px2rem(padding, 11);
          /*padding: 8px;*/
          color: #ffffff;
          text-align: left;
          border: 1px dashed #fff;
          @include px2rem(margin-bottom, 28);
          /*margin-bottom: 20px;*/
          @include px2rem(border-radius, 14);
          /*border-radius: 10px;*/
          list-style-type: none;
          // @include px2rem(margin-top, 28);
          /*margin-top: 20px;*/
        }
      }
    .about-our-bolder{
      @include px2rem(font-size, 22);
      /*font-size: 16px;*/
    }
    .about-our-size{
      @include px2rem(font-size, 18);
      /*font-size: 13px;*/
    }
    .about-our-top-img{
      /* width: 100%;
       height: 100%;*/
      @include px2rem(width, 220);
      @include px2rem(height, 220);
    }
  }

  .about-our-wrap{
    // @include px2rem(width, 1680);
    /*width: 80%;*/
  }
  .about-our-top{
    // @include px2rem(width, 1340);
    /*width: 80%;*/
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;

  }
  .about-our-top-left{
    /*width: 20%;*/
    // @include px2rem(width, 272);
    /*height: 200px;*/
   /* @include px2rem(height, 220);*/
    // @include px2rem(margin-top, 55);
    // /*margin-top: 40px;*/
    @include px2rem(margin-right, 42);
    /*margin-right: 30px;*/
  }

  .about-our-top-yellow{
    color: #ffdd11;
  }
  .about-our-top-white{
    color: #ffffff;
  }
  .about-our-bottom{
    // @include px2rem(width, 1340);
    width: 100%;
    margin: 28px auto;
  }
  .about-our-bottom-info{
    width: 100%;
    // display: flex;
  }
  .circle-img{
   /* width: 700px;
    height: 120px;*/
    @include px2rem(width, 963);
    @include px2rem(height, 165);
  }

  .circle{
    display: inline-block;
    /*width: 6px;
    height: 6px;*/
    @include px2rem(width, 9);
    @include px2rem(height, 9);
    border-radius: 50%;
    background: #fff;
    @include px2rem(margin-right, 14);
    /*margin-right: 10px;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/AboutOurThree.vue